// types
import { PaletteThemeProps } from '@assetron/common/types/theme';
import Default from './default';

// ==============================|| PRESET THEME - THEME SELECTOR ||============================== //

export default function Theme(): PaletteThemeProps {
  return Default();
}
